import { render } from "./StatusReport.vue?vue&type=template&id=6bc2b4f0&scoped=true"
import script from "./StatusReport.vue?vue&type=script&lang=js"
export * from "./StatusReport.vue?vue&type=script&lang=js"

import "./StatusReport.vue?vue&type=style&index=0&id=6bc2b4f0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc2b4f0"]])

export default __exports__